/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Identity_Username_Field_LabelInputs */

const de_identity_username_field_label = /** @type {(inputs: Identity_Username_Field_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzername`)
};

/** @type {(inputs: Identity_Username_Field_LabelInputs) => LocalizedString} */
const en_identity_username_field_label = de_identity_username_field_label;

/**

* @param {Identity_Username_Field_LabelInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const identity_username_field_label = /** @type {((inputs?: Identity_Username_Field_LabelInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Identity_Username_Field_LabelInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_identity_username_field_label(inputs)
	return en_identity_username_field_label(inputs)
});